<div class="skeleton-card hmf-display-flex hmf-mb-l">
    <hmf-skeleton
        class="hmf-px-xs hmf-pt-xxs"
        [loading]="true"
        [width]="'80px'"
        [height]="'75px'"
        [shape]="'thumbnail'">
    </hmf-skeleton>
   <div class="hmf-pt-xxs hmf-text-align-left">
    <hmf-skeleton 
        class="hmf-mb-xs"
        [loading]="true"
        [width]="'180px'"
        [height]="'14px'"
        [shape]="'text'">
        <span>Content Awaiting Load</span>
    </hmf-skeleton>
    <hmf-skeleton 
        [loading]="true"
        [width]="'90px'"
        [height]="'14px'"
        [shape]="'text'">
        <span>Content Awaiting Load</span>
    </hmf-skeleton>
   </div>
</div>
